import React, { useState } from "react"
import PropTypes from "prop-types"
//i18n
import { withTranslation } from "react-i18next"

//Import Breadcrumb
import { PageContent, CustomBreadcrumb } from "components/Common"

import CardDetail from "./CardDetail"
import { ModuleIds } from "constant"

const RESOURCE = ModuleIds.Report

const DetailContainer = ({ isEdit, t }) => {
    const titleTag = `Reports`
    const [sticky, setSticky] = useState(false);
    return (
        <PageContent title={titleTag}>
            <CustomBreadcrumb
                breadcrumbItem={t("Report Manager")}
                resource={RESOURCE}
                isDetail
                onSticky={(e) => {
                    setSticky(e)
                }}
            />
            <CardDetail isEdit={isEdit} sticky={sticky} />
        </PageContent>
    )
}

DetailContainer.propTypes = {
    t: PropTypes.any,
    isEdit: PropTypes.bool,
}

export default withTranslation(["reportPage"])(DetailContainer)
